import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

const MainLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { direction } = useLanguage();

  return (
    <div className="min-h-screen bg-background">
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <main 
        className={cn(
          'main-content',
          direction === 'rtl' 
            ? (collapsed ? 'main-content-collapsed-rtl' : 'main-content-rtl')
            : (collapsed ? 'main-content-collapsed-ltr' : 'main-content-ltr')
        )}
        data-testid="main-content"
      >
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;
